<template>
    <q-btn v-if="!connectedUser.isAudit && order?.resourceUid && checkUserByRole([MenuRoles.ROLE_MENU_PLANNIG]) && externalReference && isDeliveryAppointmentStatusAllowed(order.status.resourceUid)" @click="viewDelivery()" flat 
      unelevated
      dense>
      <img src="@/assets/icons/planning-liv-icon.svg"  alt="planning" />
      <q-tooltip>{{ $t("demand.button.goToDelivery") }}</q-tooltip>
          <template v-slot:loading>
            <q-spinner-facebook />
          </template>
    </q-btn>
  </template>
  
  <script lang="ts">
  import store from "@/store";
  import {Options, Vue} from "vue-class-component";
  import { useRoute } from "vue-router";
  import { globalConfig,checkUserByRole } from "@/utils";
  import { isDeliveryAppointmentStatusAllowed } from "@/utils/configuration-feature-flags";
import { MenuRoles, } from "@/types";
import router from "@/router";
import moment from "moment";
  
  
  
  @Options({
  })
  export default class GoToDelivery extends Vue {
    checkUserByRole = checkUserByRole
    isDeliveryAppointmentStatusAllowed = isDeliveryAppointmentStatusAllowed
    MenuRoles = MenuRoles
  
  
    get toggleShow(){
    return store.state.orderModule.showAlert
  }
  get order() {
      if( this.currentRoute === 'TaskDetail'){
          return store.state.taskModule.order
      }
      else{
          return store.state.orderModule.order;
      }
    }
    get recoverState() {
       const orderState = localStorage.getItem(globalConfig.storageKeys.orderTask)
       const orderResourceUid = orderState ? JSON.parse(orderState).resourceUid : ""
      return orderResourceUid;
    }
  
    get currentRoute() {
      return useRoute().name;
    }
    
    get externalReference(){
    if (this.order && this.order.orderItems && this.order.orderItems[0]){
      return this.order.orderItems[0].externalReference
    }
    return false
  }

    get connectedUser() {
    const user = store.getters["authModule/getUserConnected"];
    return {
      isAudit: user.authorities?.find(
        (el: { authority: string }) => el.authority === "ROLE_AUDITORS"
      ),
    };
  }

  viewDelivery() {
      store.dispatch("orderModule/setOrderToDelivery", {
      order: store.state.orderModule.order
    })
      const filter = {
              startDate : this.order && this.order.orderItems && this.order.orderItems[0].initialDeliveryDate 
              ? moment(this.order.orderItems[0].initialDeliveryDate, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD')
              : ""
            }
      store.dispatch("orderModule/setDeliveryFilter",{
          filter
      });
      router.push("/deliverySchedule");
  }


  }
  </script>
  
  <style scoped></style>
  